<template>
  <div
    ref="el"
    class="fade-content"
    :style="{
      opacity: inView ? 1 : initialOpacity,
      transform: inView ? 'translateY(0)' : 'translateY(' + translateY + 'px)',
      filter: blur ? (inView ? 'blur(0px)' : 'blur(10px)') : 'none',
      transition: 'opacity ' + duration + 'ms ' + easing + ', transform ' + duration + 'ms ' + easing + ', filter ' + duration + 'ms ' + easing,
      transitionDelay: delay + 'ms'
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FadeContent',
  props: {
    blur: { type: Boolean, default: false },
    duration: { type: Number, default: 800 },
    easing: { type: String, default: 'ease-out' },
    delay: { type: Number, default: 0 },
    threshold: { type: Number, default: 0.1 },
    initialOpacity: { type: Number, default: 0 },
    translateY: { type: Number, default: 20 }
  },
  data () {
    return {
      inView: false
    }
  },
  mounted () {
    if (!this.$refs.el) return
    this._observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this._observer.unobserve(this.$refs.el)
          this.inView = true
        }
      },
      { threshold: this.threshold }
    )
    this._observer.observe(this.$refs.el)
  },
  beforeUnmount () {
    if (this._observer) {
      this._observer.disconnect()
    }
  }
}
</script>
